import { render, staticRenderFns } from "./exclusiveProducts.vue?vue&type=template&id=6141bd60&scoped=true"
import script from "./exclusiveProducts.vue?vue&type=script&lang=js"
export * from "./exclusiveProducts.vue?vue&type=script&lang=js"
import style0 from "./exclusiveProducts.vue?vue&type=style&index=0&id=6141bd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6141bd60",
  null
  
)

export default component.exports